module.exports = __webpack_public_path__ + "img/nav.c3bf2315.svg";